import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  DEACTIVATE_TENANT_STARTING,
  DEACTIVATE_TENANT_SUCCESS,
  DEACTIVATE_TENANT_ERROR,
} from '../../../constants/actionTypes';

export default function deactivateTenantReducer(state = initialState.deactivateTenant, action) {
  switch (action.type) {
    case DEACTIVATE_TENANT_STARTING: {
      const { tenantId } = action;
      const newState = clone(state);

      if (!newState[tenantId]) {
        newState[tenantId] = clone(initialState.deactivateTenant.tenantId);
      }

      const tenantData = newState[tenantId];
      tenantData.saving = true;
      tenantData.saved = false;
      tenantData.error = null;

      return newState;
    }

    case DEACTIVATE_TENANT_SUCCESS: {
      const { tenantId } = action;
      const newState = clone(state);

      if (!newState[tenantId]) {
        newState[tenantId] = clone(initialState.deactivateTenant.tenantId);
      }

      const tenantData = newState[tenantId];
      tenantData.saving = false;
      tenantData.saved = true;
      tenantData.error = null;
      return newState;
    }

    case DEACTIVATE_TENANT_ERROR: {
      const { tenantId } = action;
      const newState = clone(state);

      if (!newState[tenantId]) {
        newState[tenantId] = clone(initialState.deactivateTenant.tenantId);
      }

      const tenantData = newState[tenantId];
      tenantData.saving = false;
      tenantData.saved = false;
      tenantData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
